/**
 * SignInAsUser
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

// Actions
import { signInAsUser } from '../../../../services/auth/actions';

export class SignInAsUser extends React.PureComponent {
    componentDidMount() {
        const { signInAsUser, hash } = this.props;
        signInAsUser(hash);
    }

    render() {
        return <Redirect to="/" />;
    }
}

SignInAsUser.propTypes = {
    signInAsUser: PropTypes.func.isRequired,
    hash: PropTypes.string.isRequired
};

export default connect(
    null,
    { signInAsUser }
)(SignInAsUser);
